export default {
    getCourses: { method: 'get', url: 'courses' },
    postCourses: { method: 'post', url: 'courses' },
    updateCourses: { method: 'put', url: 'courses/{id}' },
    deleteCourses: { method: 'delete', url: 'courses/{id}' },
}